import { jsx as w } from "react/jsx-runtime";
import { forwardRef as y } from "react";
import { Container as G } from "./styles.js";
const b = y(
  ({
    inline: o = !1,
    align: e = "flex-start",
    justify: t = "flex-start",
    wrap: n = "wrap",
    direction: i = "row",
    gap: r = 0,
    basis: f,
    grow: l,
    shrink: s,
    alignSelf: m,
    children: a,
    as: $ = "div",
    ...p
  }, x) => {
    const c = typeof r == "number" ? r : r[0], u = typeof r == "number" ? r : r[1];
    return /* @__PURE__ */ w(
      G,
      {
        ...p,
        ref: x,
        $inline: o,
        $flexDirection: i,
        $alignItems: e,
        $justifyContent: t,
        $flexWrap: n,
        $rowGap: c,
        $columnGap: u,
        $basis: f,
        $grow: l,
        $shrink: s,
        $alignSelf: m,
        as: $,
        children: a
      }
    );
  }
);
b.displayName = "Flex";
export {
  b as Flex
};
//# sourceMappingURL=Flex.js.map
